import React from 'react';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
	// could be disabled for any number of reasons for example a preview is playing
	disabled: boolean;
  onClick: () => void;
}

export default function PreviewButton(props: Props) {
	const { disabled, onClick } = props;
	return (
		<div
			className="preview-button"
			onClick={() => !disabled ? onClick() : null}
			style={{
				userSelect: 'none',
				cursor: disabled
					? 'wait'
					: 'pointer',
			}}
		>
			<span className="preview-button-text">Preview</span>
			<FontAwesomeIcon icon={faPlay} color="#A6FF79" />
		</div>
	);
}
